module.exports = __webpack_public_path__ + "static/media/wizualizacja-79.8cc23627.png";